const endpoints = {
  getInvoices: 'api/v2/users/user-id/invoices/',
}

export default endpoints
